<!-- NOTICE -->
<template>
    <div>
        <!-- // * CONTENT TITLE -->
        <v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 pl-4 pr-2 d-flex align-center white">
            <app-text category="content-title">
                <div class="d-flex align-center">
                    <v-icon v-if="form.noticeStatus === 'LIVE'"  class="display-1 success--text icons8-checkmark-yes"></v-icon>
                    <v-icon v-if="form.noticeStatus === 'DRAFT'" class="display-1 grey--text text--lighten-1 icons8-inactive-state"></v-icon>

                    <span v-if="form[collectionItem + 'Name'] === ''" class="pl-2">{{ $t(`${langPath}.new`) }}</span>
                    <span v-else class="pl-2 d-inline-block text-truncate">{{ form[collectionItem + 'Name'] }} </span>
                </div>
            </app-text>
            <v-spacer></v-spacer>
            <!-- ACTION BAR BUTTONS (CUSTOM) -->
            <div class="d-flex align-center" v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)">
                <appbutton :label="$t(`buttons.publish`)" v-if="form.noticeStatus !== 'LIVE' && formMode !== 'Edit' && formMode !== 'New' && forRead != true" icon="icons8-checkmark-yes" type="success"  class="mr-0" @click.native="updateItemStatus('LIVE')" showlabel="xlOnly" />                                                            
                <appbutton :label="$t(`buttons.hide`)" v-if="form.noticeStatus === 'LIVE' && formMode !== 'Edit' && formMode !== 'New' && forRead != true" icon="icons8-inactive-state" type="error"  class="mr-0" @click.native="updateItemStatus('DRAFT')" showlabel="xlOnly" />                                                            
            </div>
        </v-row>
        <v-divider class="grey lighten-1"></v-divider>
        <!-- // * CONTENT -->
        <v-container fluid class="pa-0"  >
            <v-row no-gutters class="">
                <v-col cols="12" xs="6" lg="12" class="">
                    <v-row class="ma-0" no-gutters>
                        <!-- // * TABS MENU (CUSTOM) -->
                        <v-tabs class="border-bottom-grey" v-model="tabs" height="53" show-arrows>
                            <v-tabs-slider color="red" background-color="black"></v-tabs-slider>
                            <v-tab href="#overview" class="white"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">{{ $t(`${langPath}.overview.tabName`) }}</span></v-tab>
                            <v-tab href="#viewer" class="white" :disabled="form.fileData === null"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">{{ $t(`${langPath}.viewer.tabName`) }}</span></v-tab>
                            </v-tabs>
                        <!-- // * TABS ITEMS -->                        
                        <v-tabs-items v-model="tabs" class="appbackground">
                            
                            <!-- OVERVIEW -->                            
                            <v-tab-item value="overview" class="pa-0">
                                <v-row v-if="forRead === true && form.mandatory === true" class="primary ma-0 pa-3">
                                   <span class="white--text mt-2">Please click once you read and understood this notice.</span> 
                                   <v-spacer/>                                               
                                    <appbutton :label="$t(`buttons.markRead`)" icon="icons8-checked-checkbox" type="secondary"  class="mr-2" @click.native="markNoticeAsRead()" showlabel="xlOnly" />                                                            
                                </v-row>
                                <v-row class="mt-4" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-2 px-2" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.overview.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help && ['CONTRACTOR'].includes(GET_currentUser.userType)">{{ $t(`${langPath}.overview.text.contractor`) }}</app-text>  
                                                <app-text category="tab-text" v-else-if="GET_help">{{ $t(`${langPath}.overview.text.default`) }}</app-text>                                                
                                                <v-divider class="my-3"/>
                                            </v-col>
                                            <!-- // * ACTION BAR -->
                                            <v-col class=" d-flex" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)">
                                                <appbutton :label="$t(`buttons.destroy`)" v-if="formMode !== 'New' && form.delete !== undefined && forRead !== true" icon="icons8-fire" type="purple"  class="mr-1" @click.native="destroyItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.undelete`)" v-if="formMode !== 'New' && form.delete !== undefined && forRead !== true" icon="icons8-process" type="purple"  class="mr-1" @click.native="undeleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.delete`)" v-if="formMode !== 'New' && form.delete === undefined && forRead !== true" icon="icons8-trash" type="secondary"  class="mr-1" @click.native="deleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.edit`)" v-if="formMode !== 'New' && forRead !== true" icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="editItem()" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly" />
                                                <v-spacer />
                                                <appbutton :label="$t(`buttons.cancel`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-cancel" type="grey darken-2"  class="mr-1" @click.native="cancelItem()" showlabel="xlOnly" />
                                                <appbutton :label="$t(`buttons.save`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-save" type="info"  class="mr-0" @click.native="validateForm()" showlabel="xlOnly" />                                                
                                            </v-col>                    
                                        </v-row>
                                        <!-- // * FORM -->  
                                        <v-form ref="form"  >
                                        <v-row class="mt-2 px-2" no-gutters>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="6" xl="6"><v-text-field color="black" :label="$t(`fields.name`)" v-model="form.noticeName" filled hide-details="auto" required :rules="rules.noticeName" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-text-field></v-col>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" color="black"  :label="$t(`fields.type`)" v-model="form.noticeType" :items="noticeTypes" filled hide-details="auto" required :rules="rules.noticeType" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                    <template v-slot:item="data">{{ data.item.text }}</template>
                                                    <template v-slot:selection="data">{{ data.item.text }}</template>                                                    
                                                </v-select>
                                            </v-col>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <v-textarea color="black"  :label="$t(`fields.description`)" v-model="form.noticeDescription" filled hide-details="auto" required :rules="rules.noticeDescription" :background-color="formBackground" auto-grow  rows="1" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                    <template v-slot:item="data">{{ data.item.text }}</template>
                                                    <template v-slot:selection="data">{{ data.item.text }}</template>
                                                </v-textarea>
                                            </v-col>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="6" v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel) && forRead === false">
                                                <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" color="black"  :label="$t(`fields.userTypes`)" v-model="form.userTypes" :items="userTypes" multiple filled hide-details="auto" required :rules="rules.userTypes" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                </v-select>
                                            </v-col>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="6" v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)  && forRead === false">
                                                <v-autocomplete color="black"  :label="$t(`fields.siteSpecific`)" v-model="form.site" :items="sites" filled hide-details="auto" required :rules="rules.site" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}">
                                                    <template v-slot:item="data">{{ data.item.siteName }}</template>
                                                    <template v-slot:selection="data">{{ data.item.siteName }}</template>                                                    
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col class="my-2 pa-1 pr-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="form.fileData !== null && ['SM','SA','DA'].includes(GET_currentUser.userLevel)  && forRead === false">
                                                <div class="d-flex align-center" style="width: 100% !important;">
                                                    <div style="width: 100% !important;"><v-text-field color="black" :label="$t('fields.file')" v-model="form.fileData.fileName"  filled hide-details="auto" required :rules="rules.fileData" :background-color="formBackground" :readonly="true" :class="{ 'disabled': true }"></v-text-field></div>
                                                    <div class="ml-4"><appbutton :label="$t(`buttons.removeFile`)" v-if="formMode !== 'New' && form.delete === undefined" icon="icons8-trash" type="secondary"  @click.native="destroyFile()" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/></div>
                                                </div>
                                            </v-col>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="form.fileData === null && formMode !== 'New' && forRead !== true">
                                                <div class="d-flex align-center" style="width: 100% !important;">
                                                    <div style="width: 100% !important;"><v-text-field color="black" :label="$t('fields.file')" filled hide-details="auto" required :rules="rules.fileData" :background-color="formBackground" :readonly="true" :class="{ 'disabled': true }"></v-text-field></div>
                                                    <div class="ml-4" v-if="formMode === 'View'"><docuploadbutton  :allowedtypes="allowedTypes" :doclink="docLink" :folder="folder" /></div>
                                                </div>
                                            </v-col>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="6" xl="6" v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel) && forRead !== true">
                                                <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" color="black"  :label="$t(`fields.status`)" v-model="form.noticeStatus" :items="noticeStatus" filled hide-details="auto" required :rules="rules.status" :background-color="formBackground" :readonly="true" :class="{ 'disabled': true }" >
                                                    <template v-slot:item="data">{{ data.item.text }}</template>
                                                    <template v-slot:selection="data">{{ data.item.text }}</template>    
                                                </v-select>
                                            </v-col>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel) && forRead !== true">
                                                <v-checkbox :label="$t(`fields.mandatoryNotice`)" :rules="rules.mandatory" required v-model="form.mandatory" />

                                            </v-col>
                                            <!-- <v-col cols="12"><pre>{{ form }}</pre></v-col> -->

                                        </v-row>
                                        </v-form>   
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- VIEWER -->
                            <v-tab-item value="viewer" class="ma-0 pa-0">
                                <v-row v-if="forRead === true && form.mandatory === true" class="primary ma-0 pa-3">
                                   <span class="white--text mt-2"> Please click once you read and understood this notice.</span> 
                                   <v-spacer/>                                               
                                    <appbutton :label="$t(`buttons.markRead`)" icon="icons8-checked-checkbox" type="secondary"  class="mr-2" @click.native="markNoticeAsRead()" showlabel="xlOnly" />                                                            
                                </v-row>
                                <docviewer></docviewer>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { mapGetters, mapState, mapActions } from 'vuex'; // Map the Getters from the Vuex Store
    export default {
        // * DATA
        data: () => ({
            // * PAGE DETAILS
            collection: 'notices',
            collectionTitle: 'Notices',
            collectionItem: 'notice',
            collectionItemTitle: 'Notice',
            langPath: 'notices.notice',
            tabs: 'overview',
            // * FORM RELATED
            form: {
                // all users manual entry
                noticeName: '', // name of notice
                noticeDescription: '', // description of notice
                noticeType: '',
                noticeStatus: 'DRAFT', // status of the notice, should be set 
                userTypes: [],// visitors / contractors / staff can specify a project / site but not mandatory
                projectId: '', // projectId should be selection based on contractor
                site: {
                    id: '',
                    siteName: '',
                    siteType: '',
                    sitePostcode: ''
                },
                fileData: null,
                mandatory: false,
            },
            rules: {},
            formMode: 'New', // Show Form in New Mode / Blank
            formReadOnly: false, // Make Form Editable
            formBackground: 'grey lighten-3',
            noticeTypes: [], // Populated by Lookup Values
            noticeStatus: [], // Populated by Lookup Values
            userTypes: [], // Populated by Lookup Values
            siteTypes: [], // Populated by Lookup Values
            sites: [], // Populated by GET_sites
            projects: [], // Populated by GET_projects
            noticeSeverities: [],
            // DOCUMENT UPLOAD
            allowedTypes: ".pdf" ,
            folder: '/notices',
            // FOR READ NOTICES
            forRead: false, // to show on the home page
            readNoticeForm: {
                readBy: '',
                notice: {
                    id: '',
                    noticeName: '',
                }
            }
        }),
        // * COMPUTED
        computed: {
            ...mapGetters({
                GET_openItem: 'GET_openNotice', // Get Open notice Data
                GET_docUploadResult: 'docUpload_store/GET_docUploadResult', // GET docUpload Result
                GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult', // Get Confirm Box Result
                GET_panelLayout: 'GET_panelLayout', // Panel Layout used for Layout Structure                
                GET_lookupValues: 'GET_lookupValues', // Get Lookup Values
                GET_sites: 'GET_sites', // Get Sites,
                GET_help: 'GET_help',
                GET_currentUser: 'GET_currentUser', // GET Current User           
            }),
            // DOC LINK (GENERIC) - REQUIRED FOR DOCUMENT UPLOAD
            docLink() {
                var t = this;
                return ({ collection: t.collection, documentId: t.form.id })
            }            
        },    
        // * WATCH
        watch: {
             // GET CONFIRMATION RESULT (CUSTOM)
            GET_confirmBoxResult: {
                handler: async function() {
                    var t = this;
                    if (t.GET_confirmBoxResult.data.collection === 'notices') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteDocumentResult = await t.MIX_deleteDocument ('notices', t.GET_confirmBoxResult.data.id);
                            var deleteLinkedResult = await t.MIX_deleteLinked (['files'], t.GET_confirmBoxResult.data.id);
                            if ((deleteDocumentResult.code === 1) && (deleteLinkedResult.code === 1)) {
                                var comment = {}
                                comment.comment = `${t.collectionItemTitle} Deleted` 
                                comment.docLink = {},
                                comment.docLink.collection = 'notices';
                                comment.docLink.documentId = t.GET_confirmBoxResult.data.id;
                                comment.private = false;
                                await t.MIX_createDocument('comments', comment);
                                t.MIX_alert(1, `Notice and File Deleted`, deleteDocumentResult.data, null);
                                t.refreshItemView();                            
                            } else {
                                t.MIX_alert(-1, `Error Deleting Notice / File`, null, null);
                            }
                        }
                    } else if (t.GET_confirmBoxResult.data.collection === 'notices/destroy') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var destroyDocumentResult = await t.MIX_destroyDocument ('notices', t.GET_confirmBoxResult.data.id);
                            var destroyFileRecordResult = await t.MIX_destroyDocument ('files', t.form.fileData.id);
                                if ((destroyDocumentResult.code === 1) && (destroyFileRecordResult.code === 1)) {
                                t.MIX_alert(1, `Notice and File Destroyed`, destroyDocumentResult.data, null);
                                t.MIX_setPanelLayout(12, 0, false, '', '');
                            } else {
                                t.MIX_alert(-1, `Error Deleting Notice & File`, null, null);
                            }
                        }
                    } else  if (t.GET_confirmBoxResult.data.collection === 'files') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteFileRecord = await t.MIX_destroyDocument('files', t.GET_confirmBoxResult.data.id);
                            if (deleteFileRecord.code === 1){
                                await t.MIX_updateDocumentFieldsById ('notices', t.form.id, { fileData: null } )
                                t.MIX_alert(1, `File Deleted`, deleteFileRecord.data, null);
                                setTimeout(function() {
                                    t.refreshItemView();                                      
                                    t.MIX_setPanelLayout(6, 6, true, 'Notice', 'notice');
                                }, 1000)
                            } else {
                                t.MIX_alert(-1, `ERROR Deleting Notice & File`, null, deleteFileRecord.error);
                            }
                        }
                    } else {
                        // Do nothing
                    }
                }, deep: true
            },
            // * GET DOCUMENT UPLOAD RESULT
            GET_docUploadResult: {
                handler: async function() {
                    var t = this;
                    var docUploadResult = t.GET_docUploadResult;
                    if (JSON.stringify(docUploadResult) !== '{}') {
                        var updateDocumentResult = await t.MIX_updateDocumentFieldsById ('notices', t.form.id, { fileData: docUploadResult } )
                        if (updateDocumentResult.code === 1) {
                            t.MIX_createDocument('files', docUploadResult)
                            t.MIX_alert(1, 'Notice Uploaded', updateDocumentResult.data, null);
                            setTimeout(function() {
                                t.refreshItemView();                                      
                                t.MIX_setPanelLayout(6, 6, true, 'Notice', 'notice');
                            }, 1000)

                        } else {
                            t.MIX_alert(-1, 'Error Uploading Notice', null, updateDocumentResult.error);
                        }
                    }
                }, deep: true
            }
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openNotice'}),            
            // UPDATE BREADCRUMBS (GENERIC)
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                if (t.GET_openItem.process === 'New') {
                    breadcrumbs.push ({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}`}) // Set a Secondary Path
                } else {
                    breadcrumbs.push ({ name: `${this.GET_openItem.data[t.collectionItem + 'Name']}`, path: `/${t.collection}/${this.GET_openItem.data.id}`}) // Set a Secondary Path
                }
                this.MIX_breadcrumbs(breadcrumbs);
            },
            // OPEN ITEM  (GENERIC)
            openItem: async function() {
                var t = this;
                var openItem = await t.GET_openItem; // Get Open Item Data
                switch (openItem.process) {
                    case 'New': 
                        t.formMode = 'New'; // Show Form in New Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                    case 'View': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details            
                        t.formMode = 'View'; // Show Form in View Mode
                        t.formReadOnly = true; // Make Form Read Only
                        t.formBackground = 'grey lighten-3'; // Change Background Colour of Form
                        break;
                    case 'Edit': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details            
                        t.formMode = 'Edit'; // Show Form in Edit Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                }              
                return;
            },
            // EDIT ITEM  (GENERIC)
            editItem() {
                var t = this;
                t.formMode = 'Edit';
                t.formReadOnly = false;
                t.formBackground = 'white';
            },
            // CANCEL ITEM  (GENERIC)
            cancelItem() {
                var t= this;
                t.formMode = 'View';
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                t.refreshItemView();  
                t.closeRightPanel();      
            },
            closeRightPanel() {
                this.updateBreadcrumbs();
                this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
            },
            // SAVE ITEM (GENERIC)
            saveItem: async function() {
                var t = this;
                if (t.form.id === undefined) {
                    t.form.id = t.MIX_generateId();  // if new then generate new id
                }
                var createDocumentResult = await t.MIX_createDocument(t.collection, t.form); // Create Document Within Firestore based on Form
                if (createDocumentResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null); // Send Success Alert to Item
                    t.formMode = 'View'; // Change Form Mode
                    t.formReadOnly = true; // Set Form to Read Only
                    t.formBackground = 'grey lighten-3';
                    t.refreshItemView();
                } else {
                    t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null); // Send Error Alert to Item
                }
            },
            // * VALIDATION RULES
			validateForm() {
				let t = this;
                t.rules = {
                    noticeName: [
                        v => !!v || 'Notice Name is required',
                        v => (v && v.length < 255) || 'Name must be less than 255 characters',
                    ],
                    noticeDescription: [v => !!v || 'Description Required'],
                    noticeType: [v => !!v || "Type Required"],
                    userTypes: [v => !!v || "User Type Required"],
                    site: [v => !!v || "Site Required"],
                    fileData: [v => !!v || 'File Required'],
                    status: [v => !!v || 'Status Required'],
                    mandatory: [v => !!v || 'Required'],
                }
                //let the DOM update
                t.$nextTick(() => {
                    //manually trigger Vuetify validation
                    if(t.$refs.form.validate()) {    
                        this.saveItem();
                    } else {
                        t.MIX_alert(-1, "Please fill out all the fields", null, null);
                    }

                    //if not valid, errors will be automatically displayed
                })
			},
            // UPDATE ITEM STATUS (GENERIC)
            updateItemStatus: async function(status) {
                var t = this;
                // console.log('updateResult')
                var updateResult = await t.MIX_updateDocumentFieldsById (t.collection, t.form.id, { [t.collectionItem + 'Status']: status } )
                // console.log('updateResult.code = ' + updateResult.code)
                var type = ['App', 'Email'];

                var sender = t.GET_currentUser.createdUserData;
                if (updateResult.code === 1) {
                    t.MIX_alert(1, 'Status Updated', updateResult.data, null);
                    t.refreshItemView();
                    // // * CREATE NOTIFICATIONS CALL
                     t.MIX_createNotification( type, 'Update Document', 'warning', 'Click to Update the Document.', 'Update Document', '/notices/' + t.form.id, sender, sender);
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateResult.error); 
                }
            },
            // REFRESH ITEM VIEW (GENERIC)
            refreshItemView: async function() {
                var t = this;
                var itemResult = await t.MIX_readDocumentById(t.collection, t.form.id)
                var payload = {}
                payload.process = 'View';
                payload.popup = false;
                payload.data = itemResult.data;
                payload.forRead = false;
                t.ACT_openItem(payload);
                t.openItem();
            },
            // DELETE ITEM METHOD (GENERIC)
            deleteItem: function (id) {
                var t = this;
                t.MIX_confirmBox(
                    { 
                        show: true,
                        collection: t.collection,
                        id: id,
                        title: `Delete ${t.collectionItemTitle}`, 
                        description: `Are you sure you want to delete ${t.collectionItemTitle}: <br /><strong>${t.form[t.collectionItem + 'Name']}</strong>?`, 
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },
			// REMOVE UPLOADED DOCUMENT
			removeUploadedDocument() {
				this.$store.commit("upload_file_store/setFile", null);
			},
            // UNDELETE ITEM METHOD (GENERIC)
            undeleteItem: async function (id) {
                var t = this;
                var undeleteResult = await t.MIX_undeleteDocument(t.collection, id)
                if (undeleteResult.code === 1) {
                    var unDeleteLinkedResult = await t.MIX_undeleteLinked (['files'],  t.form.id)                    
                    if (unDeleteLinkedResult.code === 1) {
                        t.MIX_alert(1, `${t.collectionItemTitle} Restored`, undeleteResult.data, null);
                    } else {
                        t.MIX_alert(-1, `Error Restoring File Record`, null, unDeleteFileResult.error);
                    }
                } else {
                    t.MIX_alert(-1, `Error Restoring ${t.collectionItemTitle}`, null, undeleteResult.error);
                    // console.log(`undeleteResult.error = ${JSON.stringify(undeleteResult.error, null, 2)}`)
                }
                t.refreshItemView();
            },
            // DESTROY FILE METHOD (CUSTOM)
            destroyFile: async function () {
                var t = this
                t.MIX_confirmBox(
                    { 
                        show: true,
                        collection: 'files',
                        id: t.form.fileData.id,
                        title: `Remove File`, 
                        description: `Are you sure you want to remove file: <br /><strong>${t.form.fileData.fileName}</strong>?`, 
                        width: '300',
                        height: '300',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )                               
            },
            // DESTROY ITEM METHOD (CUSTOM)
            destroyItem: async function() {
                var t = this
                t.MIX_confirmBox(
                    { 
                        show: true,
                        collection: 'notices/destroy',
                        id: t.form.id,
                        title: `Destroy Notice`, 
                        description: `Are you sure you want to destroy the notice: <br /><strong>${t.form.noticeName}</strong>?`, 
                        width: '300',
                        height: '300',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )     
            }, 
            
            // MARK NOTICE AS READ - FROM HOMEPAGE
            async markNoticeAsRead() {
                var t = this;
                // create item in notices logs
                t.readNoticeForm.notice.noticeName = t.form.noticeName;
                t.readNoticeForm.notice.id = t.form.id;
                t.readNoticeForm.readBy = t.GET_currentUser.id;
                t.readNoticeForm.docLink = {},
                t.readNoticeForm.docLink.collection = 'notices';
                t.readNoticeForm.docLink.documentId = t.form.id;
                await t.MIX_createDocument('readNoticesLogs', t.readNoticeForm);
                // add readerId in notices array
                // t.form.readBy.push(t.readNoticeForm.readBy);
                // await t.MIX_updateDocumentFieldsById (t.collection, t.form.id, { 'readBy': t.form.readBy } )
                // show alert and close view
                this.MIX_alert(1, 'Read the ' + t.form.noticeName + ' notice.', null, null);
                t.MIX_closeView(); 
            }
        },        
        // * MOUNTED
        async mounted() {
            var t = this;
            // * LOOKUP RELATED MOUNTED
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            t.noticeTypes = await t.GET_lookupValues('NOTICETYPES');
            t.noticeStatus = await t.GET_lookupValues('NOTICESTATUS');
            t.userTypes = await t.GET_lookupValues('USERTYPES');
            t.siteTypes = await t.GET_lookupValues('SITETYPES');
            // * GET SITES
            t.sites = t.GET_sites; // STORE SITES IN LOCAL ARRAY
            
            // * ITEM RELATED MOUNTED
            var openItem = await t.GET_openItem; // Get Open Project Data
            t.formMode = openItem.process; // Show Form in View Mode
            
            if(openItem.forRead != undefined){
               t.forRead = openItem.forRead; 
            }else {
                t.forRead = false;
            }
            
            // console.log(t.forRead)
            if (openItem.process === 'New') { 
                t.formReadOnly = false;             // Make Form Editable }
                t.formBackground = 'white';
                t.tabs = 'overview';                
            } else {
                t.form = openItem.data; // Update the Form with the Open Project details    
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                if (openItem.data.fileData !== null) {
                    t.MIX_docViewer ({ fileType: openItem.data.fileData.fileType, fileURL: openItem.data.fileData.fileURL } )
                    t.tabs = 'viewer';
                } else {
                    t.tabs = 'overview';
                }

            }

            if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Title
        }
    }
</script>

<style scoped>
    .disabled >>> .v-input__slot::before {
        border-style: none !important;
    }
    .v-tabs-items{
        width: 100% !important;
        height: 100% !important;
    }
    .v-window-item {
        height: calc(100vh - 170px); 
        overflow-y: auto;
    }    
</style>